class CartDrawer extends HTMLElement {
  constructor() {
    super();
      this.init();

  }

  async init() {
    this.cartDrawerButton = document.querySelector('[data-open-cart-drawer]');
    this.cartDrawerCloseButton = this.querySelector('[data-close-cart-drawer]');
    this.drawer = this.querySelector('#CartDrawer');
    this.preClasses = this.getAttribute('data-classes-pre').split(' ');
    this.postClasses = this.getAttribute('data-classes-post').split(' ');

    // Ensure elements are available before adding event listeners
    if (this.cartDrawerButton && this.cartDrawerCloseButton && this.drawer) {
      this.cartDrawerButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });

      this.cartDrawerCloseButton.addEventListener('click', (event) => {
        this.close();
      });

      document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.drawer);
        const withinButton = event.composedPath().includes(this.cartDrawerButton);
        if (!withinBoundaries && !withinButton && this.hasAttribute('data-open')) {
          this.close();
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      
    } else {
      console.error('Cart drawer elements are not found.');
    }
  }

  close() {
    this.removeAttribute('data-open');
    document.body.classList.remove('overflow-hidden');
    this.cartDrawerButton.setAttribute('aria-expanded', false);
    this.postClasses.forEach((item) => {
      this.classList.remove(item);
    });
    this.preClasses.forEach((item) => {
      this.classList.add(item);
    });

    removeTrapFocus(this.cartDrawerButton);
  }

  async open() {
    await this.render();
    
    this.setAttribute('data-open', '');
    document.body.classList.add('overflow-hidden');
    this.cartDrawerButton.setAttribute('aria-expanded', true);
    this.preClasses.forEach((item) => {
      this.classList.remove(item);
    });
    this.postClasses.forEach((item) => {
      this.classList.add(item);
    });

    trapFocus(this.drawer);
  }

  async render() {
    
    console.trace('CartDrawer.render() called');
    window.htmx.process(this);
    window.htmx.trigger("#CartDrawer", "render-cart", {});
  }
}

customElements.define('cart-drawer', CartDrawer);
